import {type ExpressionPath} from '@packages/systems/wfdl';

/**
 * We define the paths that can contain field override data here (i.e links & images as override fields)
 * TODO: Add additional test coverage https://webflow.atlassian.net/browse/DESXP-5087 for these cases
 */
const CHILDREN_PATH: ExpressionPath = [{in: 'Record', at: 'children'}];
const IMAGE_PATH: ExpressionPath = [{in: 'Record', at: 'img'}];
const IMAGE_ALT_PATH: ExpressionPath = [
  {in: 'Record', at: 'attr'},
  {in: 'Record', at: 'alt'},
];
const LINK_PATH: ExpressionPath = [{in: 'Record', at: 'link'}];
const TAG_PATH: ExpressionPath = [{in: 'Record', at: 'tag'}];
const VIDEO_PATH: ExpressionPath = [{in: 'Record', at: 'video'}];
const VISIBILITY_PATH: ExpressionPath = [
  {in: 'Record', at: 'visibility'},
  {in: 'Record', at: 'conditions'},
];

export type OverridableDataPathKey =
  | 'children'
  | 'image'
  | 'alt'
  | 'link'
  | 'tag'
  | 'video'
  | 'visibility';

export type OverridableDataPath = {
  key: OverridableDataPathKey;
  path: ExpressionPath;
};

type OverridableDataPaths = Partial<
  Record<OverridableDataPathKey, OverridableDataPath>
>;

export const OVERRIDEABLE_DATA_PATHS: OverridableDataPaths = {
  children: {
    key: 'children',
    path: CHILDREN_PATH,
  },
  image: {
    key: 'image',
    path: IMAGE_PATH,
  },
  alt: {
    key: 'alt',
    path: IMAGE_ALT_PATH,
  },
  link: {
    key: 'link',
    path: LINK_PATH,
  },
  tag: {
    key: 'tag',
    path: TAG_PATH,
  },
  video: {
    key: 'video',
    path: VIDEO_PATH,
  },
  visibility: {
    key: 'visibility',
    path: VISIBILITY_PATH,
  },
};

export const getOverridableDataPathsArray = (): OverridableDataPath[] =>
  Object.values(OVERRIDEABLE_DATA_PATHS);
